(function () {
	document.querySelectorAll("[data-filter-targets]").forEach((filterContainer) => {
		const filter = {
			container: filterContainer,
			controls: document.querySelector("[data-filter-controls='" + filterContainer.id + "']"),
			activeItems: {},
			transitionDuration: 300,
			items: filterContainer.children,
			init: function () {
				this.showAll();
				this.addControlListeners();
			},
			showAll: function () {
				for (let item of Array.from(filter.items)) {
					item.classList.add("active");
				}
			},
			hideAll: function () {
				for (let item of Array.from(filter.items)) {
					item.classList.remove("active");
				}
			},
			addControlListeners: function () {
				if (filter.controls) {
					filter.controls.querySelectorAll("[data-filter]").forEach((element) => {
						element.addEventListener("click", (event) => {
							let target = "." + element.dataset.filter;
							this.filterItem(target);
						});
					});
				}
			},
			filterItem: function (target) {
				this.hideAll();
				let activeItems = document.querySelectorAll(target);
				filter.activeItems = activeItems;

				activeItems.forEach((item) => {
					item.classList.add("active");
				});
			},
		};

		filter.init();
	});
})();
